import React from 'react';
import './brand.css';
import Loading from '../../loading';
import Server from '../../../functions/server'
import $ from "jquery";
import { Button, Icon } from 'semantic-ui-react'
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import Buttons from '@material-ui/core/Button';
import DeleteBrand from './deletebrand';
import Add from './add';
import View from './view';
import EditBrand from './editbrand';

class Brand extends React.Component {

  state = {
    addDialog: false,
    data: [],
    viewDialog: false,
    maxWidth: 'lg',
    fullWidth: true,
    editDialog: false,
    deleteDialog: false,
    deleteDialog: false,
    load: false,
    message: '',
    viewEdit: ''
  }

  componentDidMount() {
    this.getBrand();
  }

  componentDidUpdate(props) {
    if (props.partno != this.props.partno) {
      this.getBrand();
    }
  }

  upData() {
    this.getBrand();
  }

  getBrand() {
    let context = this;
    context.setState({
      load: true,
      editDialog: false,
      deleteDialog: false,
      addDialog: false,
      message: 'Getting Branch Details!!!'
    });
    let data1 = {'partno': this.props.partno};
    console.log(data1);
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'spares/getbrand.php',
      success: function(data)
      {
        console.log(data);
        context.setState({ load: false })
        let tax;
        let hsn_code;
        try {
          data = JSON.parse(data);
          for (var i = 0; i < data.length; i++) {
            data[i].sino = i + 1;
            tax = data[i].tax;
            hsn_code = data[i].hsn_code;
          }
          context.setState({
            data: data,
            newtaxvalue: tax,
            newhsncodevalue: hsn_code
          })
        } catch (e) {
          context.setState({
            load: false
          })
        }
      },
      error: function(err)
      {
        console.log(err);
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }

  handleClose = () => {
   this.setState({ viewDialog: false, addDialog: false, editDialog: false, deleteDialog: false });
  };

  makeDeciamlPoint(value) {
    try {
      value = value.toFixed(2);
    } catch (e) {
      value = 0;
    }
    return value;
  }

  addTax(dnp, tax) {
    try {
      dnp = dnp + ((dnp * tax)/100);
    } catch (e) {
      dnp = 0;
    }
    dnp = this.makeDeciamlPoint(dnp);
    return dnp;
  }

  render() {
    const { fullScreen } = this.props;
    const { load, message, addDialog, data, viewDialog, editDialog, deleteDialog } = this.state;
    return (
      <div style={{padding: '0.5%'}}>
        <Loading load={load} message={message} />
          <Paper>
            { data ?
              (
                <div>
                <table width='100%' id='table'>

                    <tr id='tablehead'>
                      <th style={{fontSize: 12, color: 'white', width: '5%'}}><center>S.No</center></th>
                      <th style={{fontSize: 12, color: 'white'}}>Part Code</th>
                      <th style={{fontSize: 12, color: 'white'}}>Brand</th>
                      <th style={{fontSize: 12, color: 'white'}}>Point</th>
                      <th style={{fontSize: 12, color: 'white'}}>Life</th>
                      <th style={{fontSize: 12, color: 'white'}}>Min Qty</th>
                      <th style={{fontSize: 12, color: 'white'}}>Wei.</th>
                      <th style={{fontSize: 12, color: 'white'}}>DNP</th>
                      <th style={{fontSize: 12, color: 'white'}}>MRP</th>
                      <th style={{fontSize: 12, color: 'white', width: '7%'}}><center>View</center></th>
                      <th style={{fontSize: 12, color: 'white', width: '7%'}}>
                      <center>Edit</center>
                      </th>
                      <th style={{fontSize: 12, color: 'white', width: '7%', display: 'none'}}>
                      <center>Delete</center>
                      </th>
                    </tr>
                    { data.map((row) => {
                        let mrp = row.mrp;
                        let tax = row.tax;
                        let dnp = row.dnp;
                        let taxablePrice;
                        try {
                          mrp = Number(mrp);
                          dnp = Number(dnp);
                          tax = Number(tax);
                          taxablePrice = mrp + (mrp * (tax/100));
                          taxablePrice = taxablePrice.toFixed(2);
                          mrp = mrp.toFixed(2);
                        } catch (e) {

                        }
                        let taxableDnp = this.addTax(dnp, tax);
                        return (
                          <tr id='rowselect'>
                            <td style={{fontSize: 14}}>{row.sino}</td>
                            <td style={{fontSize: 14}}>{row.part_code}</td>
                              <td style={{fontSize: 14}}>{row.brand}</td>
                            <td style={{fontSize: 14}}>{row.point}</td>
                            <td style={{fontSize: 14}}>{row.life}</td>
                            <td style={{fontSize: 14}}>{row.min_order_qty}</td>
                            <td style={{fontSize: 14}}>{row.weight}</td>
                            <td style={{fontSize: 14}} style={{cursor: 'pointer', color: '#416990'}} onClick={ () => { this.setState({ viewId: row.id, brandId: row.brand_id, viewDialog: true, spareTax: row.tax }) } }>
                              <u>
                                {"Rs:"+taxableDnp+"Rs:"+Number(row.dnp).toFixed(2)}
                              </u>
                            </td>
                            <td style={{fontSize: 14}} style={{cursor: 'pointer', color: '#416990'}} onClick={ () => { this.setState({ viewId: row.id, brandId: row.brand_id, viewDialog: true, spareTax: row.tax }) } }>
                              <u>
                                {"Rs:"+taxablePrice+"(Rs:"+mrp+")"}
                              </u>
                            </td>

                            <td style={{fontSize: 14}} id='pointer'
                              onClick={ () => { this.setState({ viewId: row.id, brandId: row.brand_id, viewDialog: true, spareTax: row.tax }) } }>
                              <center>View</center>
                            </td>

                            <td style={{fontSize: 14}} id='pointer'
                                onClick = { () => { this.setState({ editDialog: true, editid: row.id, asaliasId: row.alias_id })} }>
                            <center>Edit</center>
                            </td>
                            <td style={{fontSize: 14, display: 'none'}} id='pointer'
                                onClick={ () => {this.setState({ deleteDialog: true, deleteId: row.id })} }>
                            <center>Delete</center>
                            </td>
                          </tr>
                        )
                      })
                    }

                  </table>
                </div>
              ):
              (
                <div></div>
              )
            }
            <div style={{padding: '2%'}}>
              <Button primary icon labelPosition='left' onClick={ () => { this.setState({ addDialog: true}) }}
                style={{display: this.state.viewEdit}}>
                <Icon name='plus' />
                Create Spare Brand
              </Button>
            </div>
          </Paper>

          <Dialog fullScreen={fullScreen} open={addDialog}
            onClose={this.handleClose} aria-labelledby="max-width-dialog-title" >
            <DialogTitle id="responsive-dialog-title" style={{width: 500}}>
              {"Add Brand"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                <Add update={this.upData.bind(this)} handleClose={this.handleClose.bind(this)}
                     partno={this.props.partno} tax={this.props.tax} newhsncodevalue={this.state.newhsncodevalue}
                     newtaxvalue={this.state.newtaxvalue} data={this.state.data} />
              </DialogContentText>
            </DialogContent>
          </Dialog>

          <Dialog fullScreen={fullScreen} open={deleteDialog}
            onClose={this.handleClose} aria-labelledby="max-width-dialog-title" >
            <DialogTitle id="responsive-dialog-title" style={{width: 500}}>
              {"Delete Brand"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                <DeleteBrand id={this.state.deleteId} handleClose={this.handleClose.bind(this)}
                      upData={this.upData.bind(this)} />
              </DialogContentText>
            </DialogContent>
          </Dialog>

          <React.Fragment>
            <Dialog fullWidth={this.state.fullWidth}
              maxWidth={this.state.maxWidth}  open={viewDialog}
              onClose={this.handleClose} aria-labelledby="max-width-dialog-title">
              <DialogTitle id="max-width-dialog-title">View part brands</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  <View id={this.state.viewId} handleClose={this.handleClose.bind(this)}
                        upData={this.upData.bind(this)} spareTax={this.state.spareTax}
                        brandId={this.state.brandId} partno= {this.props.partno}
                        tax={this.props.tax} />
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={this.handleClose} color="primary">
                  Close
                </Button>
              </DialogActions>
            </Dialog>
          </React.Fragment>

          <React.Fragment>
            <Dialog fullWidth={this.state.fullWidth}
              maxWidth={this.state.maxWidth}  open={editDialog}
              onClose={this.handleClose} aria-labelledby="max-width-dialog-title">
              <DialogTitle id="max-width-dialog-title">Edit Brand</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  <EditBrand editid={this.state.editid} data={this.state.data}
                            update={this.upData.bind(this)}
                            handleClose={this.handleClose.bind(this)}
                            asaliasId={this.state.asaliasId}
                            tax={this.props.tax}
                            partno={this.props.partno}/>
                </DialogContentText>
              </DialogContent>
            </Dialog>
          </React.Fragment>
      </div>
    );
  }
}

export default Brand;
